import { Cloud, Database, BrainCircuit, Brain, UserCheck, Code2, Users, Lightbulb, AlertTriangle, Layers, Bitcoin, Binary, PocketKnife } from "lucide-react";
import gandalf from "../assets/gray-gandalf.png";
import { useLocalizedStrings } from "../Localization";

export default function Personality() {
  const strings = useLocalizedStrings();

  return (
    <div className="relative flex w-[90%] md:w-[80%] mx-auto my-20 bg-[#FFDCCC] border-4 border-black rounded-xl p-4 md:p-10">
      <div 
        id="projects" 
        className="absolute -top-14 left-5 bg-black text-white px-4 py-2 text-4xl rounded-t-lg"
        style={{ fontFamily: 'Bokor' }}
      >
        {strings.personality}
      </div>
      <div className="max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-lg rounded-xl border-4 border-black w-full">
        <div className="grid grid-cols-1">
          {/* Başlık ve Görsel */}
          <div className="flex justify-center my-4 md:my-6">
            <h2 className="text-xl md:text-3xl font-bold text-purple-700 text-center">
              {strings.personHead}
            </h2>
          </div>
          <div className="flex flex-col md:flex-row w-full px-5 md:px-20 items-center text-center md:text-left">
            <img src={gandalf} alt="Mimar INTJ" className="w-24 md:w-36" />
            <p className="text-gray-700 mt-4 md:mt-0 md:ml-4 text-sm md:text-lg">
              {strings.headLetter}
            </p>
          </div>
        </div>

        {/* Derinlemesine Açıklama */}
        <div className="mt-4 md:mt-6">
          <h3 className="text-lg md:text-xl font-semibold text-gray-800">{strings.asASoftwareEngineer}</h3>
          <p className="text-gray-600 mt-2 text-sm md:text-base">
            {strings.asASoftwareEngineerLetter}
          </p>
        </div>

        {/* Güçlü ve Zayıf Yönler */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 md:mt-6">
          <div className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-md md:text-lg font-semibold text-blue-600 flex items-center">
              <Brain className="w-4 h-4 md:w-5 md:h-5 mr-2" /> {strings.strength}
            </h3>
            <ul className="mt-2 text-gray-700 space-y-1 md:space-y-2 text-sm md:text-base">
              <li className="flex items-center">
                <Lightbulb className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2" /> {strings.deepAnalyticalThinking}
              </li>
              <li className="flex items-center">
                <UserCheck className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2" /> {strings.abilityToWorkIndependently}
              </li>
              <li className="flex items-center">
                <Code2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2" /> {strings.strategicPlanning}
              </li>
              <li className="flex items-center">
                <Brain className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2" /> {strings.opennesToLearningAndDevelopment}
              </li>
            </ul>
          </div>

          <div className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-md md:text-lg font-semibold text-red-600 flex items-center">
              <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 mr-2" /> {strings.weakness}
            </h3>
            <ul className="mt-2 text-gray-700 space-y-1 md:space-y-2 text-sm md:text-base">
              <li className="flex items-center">
                <Users className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2" /> {strings.dificultyInSocialComminications}
              </li>
              <li className="flex items-center">
                <Layers className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2" /> {strings.excessivePerfectionism}
              </li>
              <li className="flex items-center">
                <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2" /> {strings.lackOfFlexibility}
              </li>
              <li className="flex items-center">
                <Users className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2" /> {strings.dificultyAdaptingToTeamwork}
              </li>
            </ul>
          </div>
        </div>

        {/* Alanlarda Başarı Potansiyeli */}
        <div className="mt-4 md:mt-6">
          <h3 className="text-lg md:text-xl font-semibold text-gray-800 flex items-center">
            <PocketKnife className="w-4 h-4 md:w-5 md:h-5 mr-2" /> {strings.mostPromissingFieldsForSuccess}
          </h3>
          <ul className="mt-2 text-gray-700 space-y-1 md:space-y-2 text-sm md:text-base">
            <li className="flex items-center">
              <BrainCircuit className="w-4 h-4 md:w-5 md:h-5 text-blue-500 mr-2" /> {strings.artificalIntelligenceandMachineLearning}
            </li>
            <li className="flex items-center">
              <Database className="w-4 h-4 md:w-5 md:h-5 text-blue-500 mr-2" /> {strings.dataScienceAndBigDataAnalytics}
            </li>
            <li className="flex items-center">
              <Bitcoin className="w-4 h-4 md:w-5 md:h-5 text-blue-500 mr-2" /> {strings.blockchainAndCryptography}
            </li>
            <li className="flex items-center">
              <Cloud className="w-4 h-4 md:w-5 md:h-5 text-blue-500 mr-2" /> {strings.cloudComputingAndDistributedSystems}
            </li>
            <li className="flex items-center">
              <Binary className="w-4 h-4 md:w-5 md:h-5 text-blue-500 mr-2" /> {strings.highPerformanceAlgorithmsAndSystemDesign}
            </li>
          </ul>
        </div>
        {/* Kapanış */}
        <div className="flex justify-center mt-10">
            <button onClick={() => window.location.href = "https://www.16personalities.com/tr/intj-ki%C5%9Fili%C4%9Fi"} 
                className="px-6 py-3 bg-[#AA60C8] text-white rounded-lg shadow-md hover:bg-purple-700 transition">
                {strings.moreButton}
            </button>
        </div>
      </div>
    </div>
  );
}
